import React from 'react';
import { X } from 'lucide-react';

interface LocationPopupProps {
  isOpen: boolean;
  onClose: () => void;
}

const LocationPopup: React.FC<LocationPopupProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
      <div className="relative bg-black rounded-lg border-2 border-gold max-w-md w-full">
        <button
          onClick={onClose}
          className="absolute -top-3 -right-3 p-1 bg-black rounded-full border-2 border-gold text-gold hover:text-white transition-colors"
          aria-label="Close popup"
        >
          <X size={20} />
        </button>
        <img 
          src="https://nxnsqlrnauuqcegihtys.supabase.co/storage/v1/object/public/property-images/location-map.png" 
          alt="Service Area Map" 
          className="w-full h-auto rounded-lg"
        />
      </div>
    </div>
  );
};

export default LocationPopup;